

export function Spinner(props: {
    className?: string,
    size: "small" | "large",
}) {
    return (
        <div className={[props.className, "spinner", props.size].join(" ")}>
            <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
        </div>
    );
}
